import React, { useRef } from 'react';
import debounce from 'lodash.debounce';
import * as THREE from 'three';
import { createRoot, events, extend } from '@react-three/fiber';
import Webgl from './Webgl';

extend(THREE);

export function createProductModel(canvas: HTMLCanvasElement, modelName: string) {
    const root = createRoot(canvas);

    function onResize() {
        root.configure({
            events,
            camera: { position: [0, 0, 1.5], fov: 36, near: 0.1, far: 100 },
            gl: (canvas) => {
                const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
                renderer.toneMapping = THREE.LinearToneMapping;
                return renderer;
            },
        });
        root.render(<Webgl modelName={modelName} />);
    }

    const debouncedOnResize = debounce(onResize, 250);

    onResize();
    window.addEventListener('resize', debouncedOnResize);

    return {
        pause: () => {
            root.configure({ frameloop: 'never' });
        },
        resume: () => {
            root.configure({ frameloop: 'always' });
        },
        setProduct: (name: string) => {
            document.dispatchEvent(new CustomEvent('product-model-change', { detail: { name } }));
        },
        destroy: () => {
            window.removeEventListener('resize', debouncedOnResize);
            root.unmount();
        },
    };
}
